/**
 * Root application route configuration.
 *
 * Defines the base (empty) path of the application, protecting it with the Azure AD
 * authentication guard (MsalGuard) to ensure only authenticated users can access
 * lazily loaded feature routes.
 *
 * Lazy Loading:
 * - The home feature routes are dynamically imported from ./features/home/home.routes
 *   to optimize initial bundle size. The exported HOMEROUTES collection is used rather
 *   than a traditional NgModule, leveraging Angular’s standalone / route-level modularity.
 *
 * Security:
 * - MsalGuard enforces an authentication check and (if necessary) triggers an
 *   interactive login flow before activating the route.
 *
 * Extension Guidance:
 * - Add additional top-level routes as new objects in this array.
 * - To introduce public (unauthenticated) pages, define them before or alongside this
 *   route without the MsalGuard in their canActivate array.
 * - For preloading strategies, configure them in the RouterModule setup (not here).
 *
 * @constant
 * @public
 */
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./features/home/home.routes').then((mod) => mod.HOMEROUTES),
  },
];
